/**
 * PDP gallery: play/pause Shopify-hosted videos on slide change.
 * Only loaded when the product has video media in the gallery.
 */
(function () {
  function getAutoplayEnabled() {
    var root = document.querySelector('.product-photos[data-has-gallery-video="true"]');
    return root && root.getAttribute('data-video-autoplay') === 'true';
  }

  function pauseGalleryVideos() {
    document.querySelectorAll('.pdp-product .pdp-gallery-video').forEach(function (video) {
      if (typeof video.pause === 'function') {
        video.pause();
      }
    });
  }

  function playVideosInSlider($slider) {
    if (!getAutoplayEnabled() || !$slider || !$slider.length) {
      return;
    }

    $slider.find('.slick-current .pdp-gallery-video').each(function () {
      if (typeof this.play !== 'function') {
        return;
      }
      var playPromise = this.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function bindSlider($slider) {
    if (!$slider.length || $slider.hasClass('pdp-gallery-video-bound')) {
      return;
    }

    $slider.addClass('pdp-gallery-video-bound');
    $slider.on('afterChange', function (event, slick) {
      pauseGalleryVideos();
      playVideosInSlider($(slick.$slider));
    });
  }

  function initPdpGalleryVideo() {
    if (!document.querySelector('.product-photos[data-has-gallery-video="true"]')) {
      return;
    }

    var $primary = $('.js-slider-primary');
    var $mobile = $('.js-slider-primary-mobile');

    bindSlider($primary);
    bindSlider($mobile);

    pauseGalleryVideos();
    playVideosInSlider($primary);
    playVideosInSlider($mobile);
  }

  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).ready(function () {
      initPdpGalleryVideo();
      window.setTimeout(initPdpGalleryVideo, 600);
    });
  }
})();
